
import Vue from 'vue'
import { CreditCardPaymentForm } from '@/components'
import { Checkbox } from '@/components/formGroups'

export default Vue.extend({
   name: 'PaymentMethodCreditCard',
   data() {
      return {
         data: {
            NameOnCard: '',
            CardNumber: '',
            CardExpiryMonth: 0,
            CardExpiryYear: 0,
         },
      }
   },
   computed: {
      showErrors(): boolean {
         return this.$store.state.showErrors
      },
      saveCard(): boolean {
         return this.$store.state.purchase.SaveCreditCard
      },
   },
   methods: {
      update(data: ICreditCard) {
         this.$store.commit('setNewCreditCardData', data)
      },
      updateSaveCard() {
         this.$store.commit('setSaveCard', !this.saveCard)
      },
   },
   components: {
      CreditCardPaymentForm,
      Checkbox,
   },
})
